import register from '../../util/register'
import angular from 'angular'
import ProductionDetailsFormatter from './ProductionDetailsFormatter'
import productionDetails from './productionDetails.directive'
import MonthlyProductionController from './MonthlyProductionController'

var module = angular.module(
  'app.monthlyProductionDetails', 
  ['app.upgradeTeaser']
)

register('app.monthlyProductionDetails')
  .service('ProductionDetailsFormatter', ProductionDetailsFormatter)
  .controller('MonthlyProductionController', MonthlyProductionController)
  .directive('productionDetails', productionDetails)

module.run()
